import { QueryParam } from "../../../types/api/generic.type";
import { GetPotentialMatrixPerformanceCollaboratorsResponse } from "../../../types/api/potentialMatrix.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const PotentialMatrixPerformanceCollaboratorsService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetPotentialMatrixPerformanceCollaboratorsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response =
      await httpClient.get<GetPotentialMatrixPerformanceCollaboratorsResponse>(
        `v1/potential-matrix-performance/collaborators?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
        { signal },
      );
    return response;
  },
};

export default PotentialMatrixPerformanceCollaboratorsService;
